import { render, staticRenderFns } from "./pact.vue?vue&type=template&id=e4d7a8ba&scoped=true&"
import script from "./pact.vue?vue&type=script&lang=js&"
export * from "./pact.vue?vue&type=script&lang=js&"
import style0 from "./pact.vue?vue&type=style&index=0&id=e4d7a8ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4d7a8ba",
  null
  
)

export default component.exports